export function buildPromos() {
    if ($('#ProductGridContainer').length > 0) {
        const promos = $(".collection-promo[data-render-state='false']");
        const placementLimit = $('#product-grid')[0].children.length;
                
        promos.each(function () {
            let placement = $(this).data("placement");
            let src = $(this).data("src");
            let url = $(this).data("url");
            let text = $(this).data("text");
            let text_placement = $(this).data("text-placement");
    
    
            if (placement <= placementLimit) {
                $("#product-grid > div:nth-child(" + placement + ")").after(
                    renderPromos(url, src, text, text_placement)
                )
    
                $(this).attr("data-render-state", true);
            }
        })
    }
}

function renderPromos(url, src, text, text_placement) {
    let anchorTagSnippet = '', anchorTagClosing = '';
    if (url) {
        anchorTagSnippet = '<a class="collection-promo-link" href="' + url + '">';
        anchorTagClosing = '</a>';
    }

    return (
        '<div class="product-block collection-promo">' + anchorTagSnippet + '<img src="' +
        src +
        '"/><div class="collection-promo-text overlay-text__title collection-promo-text-placement-' +
        text_placement +
        '">' +
        text +
        "</div>" + anchorTagClosing + "</div>"
    );
}